// getStoryPreviewIds.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

import getUploadJobIds from '../selector/getUploadJobIds.js';
import getOperationData from '../selector/getOperationData.js';

import { UploadJobType } from '../resource/uploadConstants.js';
import { ProfileListMediaType } from '../resource/profileConstants.js';

const defaultArray = [];
const defaultObject = {};

/**
 * Select story draft ids
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {array} The selected story draft ids.
 */
const getStoryPreviewIds = createSelector(
  state => getOperationData(state, ['uploadJob']),
  state =>
    getUploadJobIds(
      state,
      UploadJobType.STORY,
      `${ProfileListMediaType.VIDEO},${ProfileListMediaType.IMAGE}`
    ),
  (uploadJobObject = defaultObject, uploadJobIds = defaultArray) => {
    return uploadJobIds
      .reverse()
      .map(uploadJobId => uploadJobObject[uploadJobId]?.messageId)
      .filter(messageId => !!messageId);
  }
);

export default getStoryPreviewIds;
